import React from "react";
import CareersPage from "../Components/Careers/CareersPage";

const Careers = () => {
  return <CareersPage />;
};

export default Careers;